// src/pages/profile/Profile.jsx
import { useEffect, useState } from "react";
import {
    UserCircleIcon,
    PencilSquareIcon,
} from "@heroicons/react/24/outline";
import { BASE_URL } from "../../api/config";

export default function Profile() {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const token =
                    localStorage.getItem("token") ||
                    sessionStorage.getItem("token");

                if (!token) {
                    throw new Error("Auth token missing");
                }

                const res = await fetch(
                    `${BASE_URL}/profile`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                const data = await res.json();

                if (!data.success) {
                    throw new Error("Failed to load profile");
                }

                const u = data.data.data;

                setProfile({
                    id: u.ID,
                    username: u.user_login,
                    email: u.user_email,
                    registeredAt: u.user_registered,
                    role: "Store Admin",
                    store: "Squiggles – Pune, Maharashtra",
                });
            } catch (err) {
                setError(err.message || "Something went wrong");
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);

    /* ---------------- UI STATES ---------------- */

    if (loading) {
        return (
            <div className="h-full flex items-center justify-center text-gray-500">
                Loading profile...
            </div>
        );
    }

    if (error) {
        return (
            <div className="h-full flex items-center justify-center text-red-600">
                {error}
            </div>
        );
    }

    return (
        <div className="h-full w-full bg-white p-8">
            {/* Header */}
            <div className="mb-8">
                <h1 className="text-3xl font-semibold">My Profile</h1>
                <p className="text-sm text-gray-500">
                    View your account information
                </p>
            </div>

            {/* Profile Card */}
            <div className="max-w-3xl border rounded-xl shadow-sm">
                <div className="flex items-center justify-between px-6 py-5 border-b">
                    <div className="flex items-center gap-4">
                        <UserCircleIcon className="w-16 h-16 text-gray-400" />
                        <div>
                            <h2 className="text-xl font-semibold">
                                {profile.username}
                            </h2>
                            <p className="text-sm text-gray-500">
                                {profile.role}
                            </p>
                        </div>
                    </div>

                    {/* future edit */}
                    <button
                        disabled
                        className="flex items-center gap-2 px-4 py-2 border rounded-md text-gray-400 cursor-not-allowed"
                    >
                        <PencilSquareIcon className="w-4 h-4" />
                        Edit Profile
                    </button>
                </div>

                <div className="px-6 py-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <Info label="Username" value={profile.username} />
                    <Info label="Email" value={profile.email} />
                    <Info label="User ID" value={`#${profile.id}`} />
                    <Info label="Joined On" value={profile.registeredAt} />
                    <div className="md:col-span-2">
                        <Info label="Assigned Store" value={profile.store} />
                    </div>
                </div>
            </div>
        </div>
    );
}

/* ---------- Helpers ---------- */

function Info({ label, value }) {
    return (
        <div>
            <div className="text-xs text-gray-500">{label}</div>
            <div className="mt-1 font-medium">{value}</div>
        </div>
    );
}
